import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import { toJS } from 'mobx';
import * as constants from '../../../common/constants';

const allRoles = types.model('AllRoles', {
  role: types.maybeNull(types.string),
  roleId: types.maybeNull(types.number),
  description: types.maybeNull(types.string),
  permissions: types.maybeNull(types.array(types.string), [])
});

const AllRoles = types
  .model('AllRoles', {
    data: types.optional(types.array(allRoles), []),
    success: types.maybeNull(types.string)
  })
  .actions((self) => ({
    fetch() {
      Framework.getEventManager().publish(constants.GET_ALL_ROLES);
    },
    set(response) {
      const plainData = toJS(response);
      const transformed = plainData.data.map((item) => ({
        role: item.role ?? null,
        roleId: item.role_type_id ?? null,
        description: item.description ?? null,
        permissions: Array.isArray(item.permissions) ? item.permissions.filter((p) => typeof p === 'string') : []
      }));
      applySnapshot(self.data, transformed);
    }
  }));

export default AllRoles;
